import type { SVGProps } from 'react';

const SvgNestCamWiredStand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="m18 .85-6.02.55C8.95 1.7 6.37 4 6.04 7.03a6.36 6.36 0 0 0 5.68 7.04l1.9.19-.56.85c-.88-.19-1.83-.18-2.85.25-2 .85-3.21 2.89-3.21 5.05V23h10v-3c0-1.67-.83-3.15-2.09-4.06l.97-1.45 2.12.23z" />
  </svg>
);
export default SvgNestCamWiredStand;
